import { useEffect, useState } from "react";
import ILogin_Message_Detail from "../../../models/ILogin_Message_Detail";
import moment from "moment-timezone";
import "./LoginMessage.scss";

type LoginMessageProps = {
    loginMessageDetail?: ILogin_Message_Detail;
    showPreviewBox: boolean;
};

export const LoginMessage = (props: LoginMessageProps) => {
    const isActiveLoginMessage = (): boolean => {
        if (props.loginMessageDetail) {
            const today = moment();

            const beginsAt = moment(props.loginMessageDetail.begins_at);
            const expiresAt = moment(props.loginMessageDetail.expires_at);

            return today.isBetween(beginsAt, expiresAt);
        } else {
            return false;
        }
    };

    const getVisibility = (): boolean => {
        if (props.loginMessageDetail) {
            if (props.showPreviewBox) {
                return true;
            } else {
                if (!isActiveLoginMessage()) {
                    return false;
                } else {
                    return true;
                }
            }
        } else {
            return false;
        }
    };

    const [visible] = useState(getVisibility());
    const [selectedColor] = useState<string>(
        props.loginMessageDetail?.color ? props.loginMessageDetail?.color : "#FFFFFF"
    );
    const [isMessageHidden, setIsMessageHidden] = useState(!props.showPreviewBox);

    useEffect(() => {
        // validate the date is active
        if (props.loginMessageDetail) {
            if (!props.showPreviewBox) {
                const _isMessageHidden = hasMessageBeenDismissed();
                setIsMessageHidden(_isMessageHidden);
            }
        }
    }, []);

    const hideMessage = () => {
        setMessageDismissed();

        setIsMessageHidden(true);
    };

    const viewMessage = () => {
        setIsMessageHidden(false);
    };

    const setMessageDismissed = (): void => {
        if (props.loginMessageDetail) {
            const encodedLoginMessage = btoa(JSON.stringify(props.loginMessageDetail));
            localStorage.setItem("loginSupplierMessage", encodedLoginMessage);
        }
    };

    const hasMessageBeenDismissed = (): boolean => {
        if (props.loginMessageDetail) {
            const encodedLoginMessage = btoa(JSON.stringify(props.loginMessageDetail));
            const loginMessage = localStorage.getItem("loginSupplierMessage");

            const isDismissed = (loginMessage && loginMessage === encodedLoginMessage) || false;

            console.log("hasMessageBeenDismissed: ", isDismissed);

            return isDismissed;
        } else {
            return false;
        }
    };

    return visible ? (
        <div>
            <div
                className={"LoginMessage pt-0 pb-0 position-relative dashboard-widget " + (isMessageHidden ? "d-none" : "")}
                style={{
                    color: selectedColor,
                    minHeight: "7.625rem",
                    border: `1px solid ${selectedColor}`,
                    padding: "1rem",
                }}>
                <div className={"text-end pt-2"}>
                    <i className={"fa fa-times pointer"} onClick={hideMessage}></i>
                </div>
                <div className={"d-flex"}>
                    <div className={"icon"}>
                        <h3>
                            <i className={props.loginMessageDetail?.icon + " me-2"}></i>
                        </h3>
                    </div>
                    <div className={"content"}>
                        <h3>{props.loginMessageDetail?.title}</h3>
                        <p dangerouslySetInnerHTML={{ __html: props.loginMessageDetail?.detail || "" }}></p>
                    </div>
                </div>
            </div>

            <div className={isMessageHidden ? "" : "d-none"}>
                <div className={"text-primary"}>
                    <span className={"pointer"} onClick={viewMessage}>
                        <i className={"fa fa-eye"}></i> Show Message
                    </span>
                </div>
            </div>
        </div>
    ) : null;
};
